import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from './StoryAndSourceChecker.ducks';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';

// landscape components
import Loading from 'zignal-landscape/lib/Loading';
import Modal from 'zignal-landscape/lib/Modal';
import ModalHeader from 'zignal-landscape/lib/ModalHeader';
import ModalBody from 'zignal-landscape/lib/ModalBody';
import ModalFooter from 'zignal-landscape/lib/ModalFooter';
import themeable from 'zignal-landscape/lib/themeable';


// presentational components
import CheckerModalForm from './components/CheckerModalForm';
import CheckerModalFooter from './components/CheckerModalFooter';
import ResultList from './components/ResultList';
import {MODAL_STAGES} from './StoryAndSourceChecker.ducks';
import StoryCheckerDetail from './components/StoryCheckerDetail';

export const mapStateToProps = (
  (state) => ({
    isModalOpen: state.StoryAndSourceChecker.isModalOpen,
    isFetching: state.StoryAndSourceChecker.isFetching,
    modalStage: state.StoryAndSourceChecker.modalStage,
    selectedCheckByOption: state.StoryAndSourceChecker.selectedCheckByOption,
    // NOTE: "SourceType" is the 'type of Source being checked' vs. a Source Type like 'twitter', 'blogs', etc.
    selectedSourceOrStoryType: state.StoryAndSourceChecker.selectedSourceOrStoryType,
    sourcesOrStoriesToCheck: state.StoryAndSourceChecker.sourcesOrStoriesToCheck,
    sourceCheckerResults: state.StoryAndSourceChecker.sourceCheckerResults,
    storyCheckerResults: state.StoryAndSourceChecker.storyCheckerResults,
    storyCheckerDetail: state.StoryAndSourceChecker.storyCheckerDetail,
    filters: state.StoryAndSourceChecker.filters,
    sourceCheckerSimilars: state.StoryAndSourceChecker.sourceCheckerSimilars,
    showSourceCheckerSimilars: state.StoryAndSourceChecker.showSourceCheckerSimilars,
    fetchingSimilarFor: state.StoryAndSourceChecker.fetchingSimilarFor,
    selectedProfiles: state.StoryAndSourceChecker.selectedProfiles,
    selectedSource: state.StoryAndSourceChecker.selectedSource,
    title: state.StoryAndSourceChecker.title,
    handleTitleChanged: state.StoryAndSourceChecker.handleTitleChanged,
    includeAll : state.StoryAndSourceChecker.includeAll,
    handleIncludeAll : state.StoryAndSourceChecker.handleIncludeAll,
  })
);

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

const CHECKER_ITEMS_LIMIT = {
  sources: 499,
  stories: 999
};

class StoryAndSourceChecker extends Component {

  constructor(props) {
    super(props);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.onBackButtonClick = this.onBackButtonClick.bind(this);
    this.getModalTitle = this.getModalTitle.bind(this);
    this.renderResultsSection = this.renderResultsSection.bind(this);
    this.renderCheckerFormSection = this.renderCheckerFormSection.bind(this);
    this.renderDetailSection = this.renderDetailSection.bind(this);
    this.onShowSimilarSources = this.onShowSimilarSources.bind(this);
    this.onHideSimilarSources = this.onHideSimilarSources.bind(this);
  }

  componentDidMount() {
    this.props.setModalVisibility(true);
  }

  onCloseModal() {
    this.props.clearModalForm();
    this.props.setModalVisibility(false);
  }

  onNextButtonClick() {
    const { campaignId, fetchSourceCheckerResults, selectedCheckByOption, fetchStoryCheckerResults} = this.props;
    if (selectedCheckByOption === 'sources') {
      fetchSourceCheckerResults(campaignId);
    } else {
      fetchStoryCheckerResults(campaignId);
    }
  }

  onBackButtonClick(toStage) {
    this.props.setModalStage(toStage);
  }

  onShowSimilarSources(mediaOutlet) {
    const { campaignId, fetchSourceCheckerSimilars } = this.props;
    fetchSourceCheckerSimilars({ campaignId, mediaOutlet });
  }

  onHideSimilarSources(mediaOutlet) {
    this.props.handleHideSimilarSources(mediaOutlet);
  }

  getModalTitle(option) {
    switch (option) {
      case 'sources':
        return 'Check Sources';
      case 'stories':
        return 'Check Stories';
      default:
        return 'Check Sources and Stories';
    }
  }

  renderResultsSection() {
    const {
      selectedCheckByOption,
      selectedSourceOrStoryType,
      sourceCheckerResults,
      storyCheckerResults,
      sourceCheckerSimilars,
      filters,
      profiles,
      campaignName,
      handleFilterChange,
      showSourceCheckerSimilars,
      fetchingSimilarFor,
      hasGroups,
      sourcesOrStoriesToCheck,
      title,
      styles,
      selectedSource,
    } = this.props;

    const resultList = selectedCheckByOption === 'sources' ? sourceCheckerResults : storyCheckerResults;
    let storyTextTitle = null;
    if (selectedSourceOrStoryType === 'content') {
      storyTextTitle = title ? title : sourcesOrStoriesToCheck.substr(0, 300);
    }

    return (
      <div className={styles.ResultListWrapper}>
        <ResultList
          selectedCheckByOption={selectedCheckByOption}
          selectedSourceOrStoryType={selectedSourceOrStoryType}
          results={resultList}
          filters={filters}
          onFilterChange={handleFilterChange}
          onShowSimilarSources={this.onShowSimilarSources}
          onHideSimilarSources={this.onHideSimilarSources}
          sourceCheckerSimilars={sourceCheckerSimilars}
          showSourceCheckerSimilars={showSourceCheckerSimilars}
          fetchingSimilarFor={fetchingSimilarFor}
          hasGroups={hasGroups}
          campaignName={campaignName}
          profiles={profiles}
          storyTextTitle={storyTextTitle}
          storyDetailHandler={this.props.fetchStoryCheckerDetail}
          selectedSource={selectedSource}
        />
      </div>
    );
  }

  renderCheckerFormSection() {
    const { selectedCheckByOption, sourcesOrStoriesToCheck,
      selectedSourceOrStoryType, editSourcesOrStoriesList, setCheckBy,
      setSourceType, profiles, handleProfilesChange, selectedProfiles, selectedSource, title, handleTitleChanged,
      includeAll, handleIncludeAll, handleSourceSelection
    } = this.props;
    const sourcesToCheckItems = sourcesOrStoriesToCheck.match(/\n/g) || [];
    const hasSourcesExceededLimit = sourcesToCheckItems.length > CHECKER_ITEMS_LIMIT[selectedCheckByOption];

    const commaSeparatedDomains = sourcesOrStoriesToCheck.match(/[,]/gm) || [];
    const hasDomainsCommaSeparatedValues = selectedSourceOrStoryType === 'domain'
      && commaSeparatedDomains.length > 0;

    return (
      <CheckerModalForm
        hasSourcesExceededLimit={hasSourcesExceededLimit}
        hasDomainsCommaSeparatedValues={hasDomainsCommaSeparatedValues}
        selectedCheckByOption={selectedCheckByOption}
        sourcesOrStoriesToCheck={sourcesOrStoriesToCheck}
        selectedSourceOrStoryType={selectedSourceOrStoryType}
        editSourcesOrStoriesList={editSourcesOrStoriesList}
        setCheckBy={setCheckBy}
        setSourceOrStoryType={setSourceType}
        profiles={profiles}
        selectedProfiles={selectedProfiles}
        selectedSource={selectedSource}
        handleProfilesChange={handleProfilesChange}
        handleSourceSelection={handleSourceSelection}
        title={title}
        handleTitleChanged={handleTitleChanged}
        includeAll={includeAll}
        handleIncludeAll={handleIncludeAll}
      />
    );
  }

  renderDetailSection() {
    const { title, body, profileId, accountName, url } = this.props.storyCheckerDetail;
    const profile = find(this.props.profiles, ((p) => p._id === profileId));
    return (
      <StoryCheckerDetail
        body={body}
        title={title}
        url={url}
        accountName={accountName}
        campaignName={this.props.campaignName}
        profileName={profile.name}
      />
    );
  }

  // eslint-disable-next-line complexity
  render() {
    const { styles, isModalOpen, modalStage, isFetching,
      selectedCheckByOption, selectedSourceOrStoryType, sourcesOrStoriesToCheck,
      selectedProfiles, selectedSource
    } = this.props;

    let modalHeaderTitle;
    let modalBodyContent;
    let previousStage;
    switch (modalStage) {
      case MODAL_STAGES.search:
        modalHeaderTitle = 'Check Sources and Stories';
        modalBodyContent = this.renderCheckerFormSection;
        previousStage = null;
        break;
      case MODAL_STAGES.results:
        modalHeaderTitle = this.getModalTitle(selectedCheckByOption);
        modalBodyContent = this.renderResultsSection;
        previousStage = MODAL_STAGES.search;
        break;
      case MODAL_STAGES.resultDetail:
        modalHeaderTitle = 'Story Details';
        modalBodyContent = this.renderDetailSection;
        previousStage = MODAL_STAGES.results;
        break;
      default:
        throw new Error(`Unknown modal stage '${modalStage}'`);
    }

    const modalBodyContainer = isFetching
      ? <div className={styles.modalLoadingContainer}><Loading blockUi={false} /></div>
      : modalBodyContent();

    const sourcesToCheckItems = sourcesOrStoriesToCheck.match(/\n/g) || [];
    const hasSourcesExceededLimit = sourcesToCheckItems.length > CHECKER_ITEMS_LIMIT[selectedCheckByOption];

    const commaSeparatedDomains = sourcesOrStoriesToCheck.match(/[,]/gm) || [];
    const hasDomainsCommaSeparatedValues = selectedSourceOrStoryType === 'domain'
      && commaSeparatedDomains.length > 0;
    const isStoryUrlFormInvalid = selectedSourceOrStoryType === 'urls'
      && selectedProfiles.length === 0;
    const isStoryContentFormInvalid = selectedSourceOrStoryType === 'content'
      && selectedProfiles.length === 0;
    const isFormInvalid = isEmpty(selectedSourceOrStoryType)
      || isEmpty(sourcesOrStoriesToCheck)
      || hasSourcesExceededLimit
      || hasDomainsCommaSeparatedValues
      || isStoryUrlFormInvalid
      || isStoryContentFormInvalid
      || !selectedSource;

    return (
      <Modal
        isOpen={isModalOpen}
        size="large"
        onEscapePress={this.onCloseModal}
        onBackdropClick={this.onCloseModal}
      >
        <ModalHeader onClose={this.onCloseModal}>
          {modalHeaderTitle}
        </ModalHeader>
        <div>
          <ModalBody>
            {modalBodyContainer}
          </ModalBody>
        </div>
        <ModalFooter>
          <CheckerModalFooter
            modalStage={modalStage}
            isNextButtonDisabled={isFormInvalid}
            onCloseModal={this.onCloseModal}
            onNextButtonClick={this.onNextButtonClick}
            onBackButtonClick={() => this.onBackButtonClick(previousStage)}
          />
        </ModalFooter>
      </Modal>
    );
  }
}

StoryAndSourceChecker.propTypes = {
  styles: PropTypes.object,
  selectedSourceOrStoryType: PropTypes.string,
  isModalOpen: PropTypes.bool,
  isFetching: PropTypes.bool,
  modalStage: PropTypes.string,
  campaignId: PropTypes.string,
  campaignName: PropTypes.string,
  sourcesOrStoriesToCheck: PropTypes.string,
  selectedCheckByOption: PropTypes.string,
  sourceCheckerResults: PropTypes.array,
  storyCheckerResults: PropTypes.array,
  storyCheckerDetail: PropTypes.object,
  sourceCheckerSimilars: PropTypes.object,
  clearModalForm: PropTypes.func,
  editSourcesOrStoriesList: PropTypes.func,
  fetchSourceCheckerResults: PropTypes.func,
  fetchStoryCheckerResults: PropTypes.func,
  fetchSourceCheckerSimilars: PropTypes.func,
  fetchStoryCheckerDetail: PropTypes.func,
  setCheckBy: PropTypes.func,
  setSourceType: PropTypes.func,
  setModalStage: PropTypes.func,
  setModalVisibility: PropTypes.func,
  filters: PropTypes.object,
  handleFilterChange: PropTypes.func,
  handleHideSimilarSources: PropTypes.func,
  showSourceCheckerSimilars: PropTypes.object,
  fetchingSimilarFor: PropTypes.string,
  hasGroups: PropTypes.bool,
  profiles: PropTypes.array,
  handleProfilesChange: PropTypes.func,
  handleSourceSelection: PropTypes.func.isRequired,
  selectedProfiles: PropTypes.array,
  selectedSource: PropTypes.string,
  title: PropTypes.string,
  handleTitleChanged: PropTypes.func,
  includeAll: PropTypes.bool,
  handleIncludeAll: PropTypes.func,
};

StoryAndSourceChecker.defaultProps = {
  selectedSourceOrStoryType: undefined,
  sourcesOrStoriesToCheck: '',
  title: '',
  modalStage: MODAL_STAGES.search
};

export default connect(mapStateToProps, actions, mergeProps)(themeable(StoryAndSourceChecker));
